import React, { useEffect, useState } from 'react';
import MyDependents from './MyDependents';
import MyGuardians from './MyGuardians';
import MyProfile from './MyProfile';
import useFetchData from '../../../utilFunctions/useFetchData';
import {
  gaurdianDetailReq,
  dependentsReq,
  addGaurdianDetailReq,
  updateGaurdianDetailReq,
  deleteGaurdianDetailReq,
  getGuardianRelationsList
} from '../../../utilFunctions/profile/MyFamilyProfile';
import { useDispatch,useSelector } from 'react-redux';
import { modalActions, portalActions } from '../../../store';
import Loader from '../../UI/Loader';
import { selectLanguage } from '../../../store/languageSlice';
import { selectModal } from '../../../store/globalModalSlice';

export default function FamilyProfile() {
  const dispatch = useDispatch();
  const { t } = useSelector(selectLanguage);
  let { data: gaurdianDetails, refetch: refetchGuardianDetails } =
    useFetchData(gaurdianDetailReq);
    const { data: patientsRelations } = useFetchData(getGuardianRelationsList);
  const { data: dependentsData, loading, error } = useFetchData(dependentsReq);
  const userInfo = JSON.parse(localStorage.getItem('userInfo'));
  const { switchPatient } = useSelector(selectModal);
  const [guardianRemoveMsg, setGuardianRemoveMsg] = useState(null);
  const [guardianMsgType, setGuardianMsgType] = useState('success');

  const previousUserInfo = JSON.parse(localStorage.getItem('previousUserInfo'))

  const handleOnAddGuardian = async (guardianData) => {
    const requestBody = {
      patId: userInfo?.mrn || '22',
      hosp: '1',
      guardianId: guardianData?.mrNumber,
      noOfDays: guardianData?.noOfDays,
      consent: gaurdianDetails?.consent || 1,
      isActive: gaurdianDetails?.isActive || 1,
      guardianRelation: guardianData?.guardianRelation
    };

    if (guardianData.type == 'add') {
      // await addGaurdianDetailReq(requestBody);
      const responseData = await addGaurdianDetailReq(requestBody);
      if(responseData.status === "false") {
        setGuardianRemoveMsg(responseData.message);
        setGuardianMsgType("fail")
        return;
      }
      if(responseData.status === "true") {
        setGuardianRemoveMsg(responseData.message);
        setGuardianMsgType('success');
      }
      refetchGuardianDetails();
    }

    if (guardianData.type == 'edit') {
      // await updateGaurdianDetailReq(requestBody);
      const responseData = await updateGaurdianDetailReq(requestBody);
      if(responseData.status === "true") {
        setGuardianRemoveMsg(responseData.message);
        setGuardianMsgType('success');
      }
      refetchGuardianDetails();
    }
    // dispatch(portalActions.closeDrawer());
  };

  const handleOnDependentClick = (selectedDependant) => {
    // can not switch again if already dependent switched
    if(!switchPatient) {
      dispatch(portalActions.updatedSelectedDependent(selectedDependant));
    }
    dispatch(modalActions.toggle('dependentModal'));
  };

  const handleOnDeleteGuardian = async (data) => {
    const responseData = await deleteGaurdianDetailReq(gaurdianDetails?.guardianId);
    if(responseData.status === "true") {
      setGuardianRemoveMsg(responseData.message);
    }
    // dispatch(portalActions.closeDrawer());
  };

  const handleSwitchBackClick = () => {
    let previousUserInfo = JSON.parse(localStorage.getItem('previousUserInfo'));
    localStorage.setItem('userInfo', JSON.stringify(previousUserInfo));
    localStorage.removeItem('previousUserInfo');

    setTimeout(() => {
      dispatch(modalActions.setSwitchPatient(false));
    }, 1000);

    window.location.reload();
  };

  if (loading) return <Loader />;

  if (error) return <div className="p-8">{t.Something_Wrong}</div>;

  return (
    <div>
      <div className="px-4">
        {!switchPatient ?
        <>
        <MyGuardians
          data={gaurdianDetails}
          onAddGuadrian={handleOnAddGuardian}
          onDeletGuadrian={handleOnDeleteGuardian}
          patientsRelations={Array.isArray(patientsRelations) ? patientsRelations : []}
          onGuardianRemoveMsg={guardianRemoveMsg}
          messageType={guardianMsgType}
        />
        <MyDependents
          data={dependentsData}
          onClickDependent={handleOnDependentClick}
        />
        </>
        : <MyProfile data={previousUserInfo} onClick={handleSwitchBackClick} />}
      </div>
    </div>
  );
}
